const DummyLabelValues = [
    'Abbreviation',
    'AccountName',
    'ActorName',
    'Altitude',
    'AreaCircle',
    'Bic',
    'BitcoinAddress',
    'BloodType',
    'BodyPartExternal',
    'BodyPartInternal',
    'BodyRegion',
    'BodySystem',
    'BuildingNumber',
    'CardinalDirection',
    'Categories',
    'City',
    'CityPrefix',
    'CitySuffix',
    'Color',
    'CompanyName',
    'CompanySuffix',
    'Country',
    'CountryCode',
    'County',
    'CreditCardCvv',
    'CreditCardNumber',
    'Currency',
    'Department',
    'Depth',
    'DiagnosisCode',
    'DiagnosisEntry',
    'DiagnosisLongDescription',
    'DiagnosisShortDescription',
    'Digits',
    'Direction',
    'DomainName',
    'DomainSuffix',
    'DomainWord',
    'Dosage',
    'DosageAmount',
    'DosageForm',
    'Email',
    'EthereumAddress',
    'ExampleEmail',
    'FirstName',
    'Fuel',
    'FullAddress',
    'FullName',
    'Geohash',
    'Hospital',
    'HospitalCity',
    'HospitalName',
    'HospitalState',
    'HospitalStreetAddress',
    'HospitalZipCode',
    'Iban',
    'InfectiousDisease',
    'Ingredient',
    'IpAddress',
    'IpEndPoint',
    'Ipv6',
    'Ipv6Address',
    'Ipv6EndPoint',
    'JobArea',
    'JobDescriptor',
    'JobTitle',
    'JobType',
    'LastName',
    'Latitude',
    'Longitude',
    'Manufacturer',
    'Model',
    'Month',
    'MovieCollection',
    'MovieOverview',
    'MovieReleaseDate',
    'MovieTagline',
    'MovieTitle',
    'Nature',
    'Network',
    'Number',
    'OrdinalDirection',
    'Pain',
    'PhoneNumber',
    'Plasma',
    'Prefix',
    'Price',
    'ProcedureCode',
    'ProcedureEntry',
    'ProcedureLongDescription',
    'ProcedureShortDescription',
    'Product',
    'ProductAdjective',
    'Production',
    'ProductMaterial',
    'ProductName',
    'Review',
    'RoutingNumber',
    'SecondaryAddress',
    'Series',
    'Sentence',
    'State',
    'StateAbbr',
    'StreetAddress',
    'StreetName',
    'StreetSuffix',
    'Suffix',
    'TransactionType',
    'Type',
    'Url',
    'UrlRootedPath',
    'UrlWithPath',
    'UserName',
    'UserNameUnicode',
    'Vin',
    'Vitamin',
    'Weekday',
    'ZipCode',
    'No Match',

];

const TypeMap = [
    { type: 'URL', value: 'Url' },
    { type: 'Email', value: 'Email' },
    { type: 'Html', value: 'Nature' },
    { type: 'Multiline Text', value: 'Sentence' },
];

const getDummyLabel = (name, type) => {
    let nameWithoutSpecialCharacter = name.replace(/[^a-zA-Z]/g, "").toLowerCase();
    let DummyLabel = ""
    if (
        type === "URL" ||
        type === "Email" ||
        type === "Html" ||
        type === "Multiline Text"
    ) {
        let filterValue = TypeMap.find(type => type.type = type).value
        let filterLabels = DummyLabelValues.filter(label => label === filterValue)
        DummyLabel = filterLabels.find(label => label.toLowerCase() === nameWithoutSpecialCharacter) || "No Match"
    } else {
        DummyLabel = DummyLabelValues.find(label => label.toLowerCase() === nameWithoutSpecialCharacter) || "No Match"
    }
    return DummyLabel
}

export default {
    DummyLabelValues,
    TypeMap,
    getDummyLabel
}